import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'app/main/globals';

@Injectable({
  providedIn: 'root'
})
export class AspClutchKitFlowService {
  paramData: { authKey: any; source: string; };

  constructor(  private http: HttpClient) { }
  getAllKits() {
    return this.http.get(
      `${GlobalVariable.BASE_API_URL_SPARES}/api/v1/service/kits`
    );
  }
}
